const FIELDWORK_DEV_DOMAIN = 'https://dev-fieldwork.chorus.co.nz'
const FIELDWORK_SIT_DOMAIN = 'https://sit-fieldwork.chorus.co.nz'
const FIELDWORK_PPE_DOMAIN = 'https://ppe-fieldwork.chorus.co.nz'
const FIELDWORK_PROD_DOMAIN = 'https://fieldwork.chorus.co.nz'

const URL = window.location.href

// Get current environment name
let environment = 'LOCAL'

if (URL.includes(FIELDWORK_PROD_DOMAIN)) {
  environment = 'PROD'
} else if (URL.includes(FIELDWORK_PPE_DOMAIN)) {
  environment = 'PPE'
} else if (URL.includes(FIELDWORK_SIT_DOMAIN)) {
  environment = 'SIT'
} else if (URL.includes(FIELDWORK_DEV_DOMAIN)) {
  environment = 'DEV'
}

export const ENV = environment

export const AZURE_AUTH_ENABLED = true

let clientID = ''
let scopes = [] as string[]
let camsApiBaseUrl = ''
let fmpApiBaseUrl = ''
let nrmApiBaseUrl = ''
let plantApiBaseUrl = ''

// NRM
let nrmBasicAuthUsername = 'fb6ee24c33494a99809bd5f038602177'
let nrmBasicAuthSecret = 'EeE9C8926A25481EaaAe7b3c8866a75b'

// PLANT
const plantLinzMapApiKey = 'c01kkw8wk1p7t7fkb03krcvgtqm'
let plantBasicAuthUsername = '92c2f1b7fa684ae3919130c6568d1864'
let plantBasicAuthSecret = 'AC47df85c01b47F5806b018c110AA863'

// to use without JWT
let basicAuthUsername = 'ed07a0e6a1d34fe69dc88e9cd8dc9b68'
let basicAuthSecret = 'C845B294ac0346bE81ABeCAb0349ccF1'

if (AZURE_AUTH_ENABLED) {
  // to use with JWT
  switch (ENV) {
    case 'PROD':
      basicAuthUsername = 'ff80bbc26c3b4f4087730543ddc6fdf1'
      basicAuthSecret = 'C793f87b22714eECA3b2fCdCdF4f9A84'
      nrmBasicAuthUsername = 'c62a624a896b4606b21250720fecf054'
      nrmBasicAuthSecret = 'fC5cAd87C728401bb46A7Bf8a9Dba9b6'
      plantBasicAuthUsername = '89c86652937a4085be0ef2b48f39c4b2'
      plantBasicAuthSecret = '302ddE21565940b4B877A29E6dBd4210'
      break

    case 'PPE':
      basicAuthUsername = 'a63a0e03753643249f7892df74e86d47'
      basicAuthSecret = 'Bc41e83377934d06BBc83De3Cf6F5bb0'
      nrmBasicAuthUsername = 'af6363723b4d45e8967494019e0ceb3e'
      nrmBasicAuthSecret = '03694Dd6287A4480Aec7Edc13fBEB8Ec'
      plantBasicAuthUsername = 'c6a4d1caa8bb415482ef46c5d9d02132'
      plantBasicAuthSecret = 'd2868F91D4104190aed2edEa964bC354'
      break

    default:
      // SIT and DEV
      basicAuthUsername = '61e64ea9ace14bd6a9677c0b04a78423'
      basicAuthSecret = 'f4f7Fff2EFcf4c89A4C8A294821f5B37'
  }
}

scopes = [`${window.location.protocol}//${window.location.hostname}/FieldWork.All`]

switch (ENV) {
  case 'PROD':
    clientID = 'a37629f2-2c9f-49e7-9c45-f3aaea5fbadd'
    camsApiBaseUrl = 'https://api.chorus.co.nz'
    fmpApiBaseUrl = 'https://api.chorus.co.nz/fre/v1'
    nrmApiBaseUrl = 'https://api.chorus.co.nz/nrd/v1'
    plantApiBaseUrl = 'https://api.chorus.co.nz/plant/v1'
    break

  case 'PPE':
    clientID = '9eb3583c-dd14-4dd2-8852-05b642d53664'
    camsApiBaseUrl = 'https://api.ppe.chorus.co.nz'
    fmpApiBaseUrl = 'https://api.ppe.chorus.co.nz/fre/v1'
    nrmApiBaseUrl = 'https://api.ppe.chorus.co.nz/nrd/v1'
    plantApiBaseUrl = 'https://api.ppe.chorus.co.nz/plant/v1'
    break

  case 'SIT':
    clientID = 'c0b217e8-b35e-4a11-bdad-a9d7d8b10f2a'
    camsApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz'
    fmpApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/fre/v1'
    nrmApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/nrd/v1'
    plantApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/plant/v1'
    break

  default:
    // same as SIT
    clientID = 'c0b217e8-b35e-4a11-bdad-a9d7d8b10f2a'
    camsApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz'
    fmpApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/fre/v1'
    nrmApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/nrd/v1'
    plantApiBaseUrl = 'https://cloudhub.sit.chorus.co.nz/plant/v1'
    break
}

export const AZURE_CLIENT_ID = clientID
export const AZURE_TENANT_ID = '41360c96-1755-4bf8-8527-81bb0ad2ac43'
export const AZURE_SCOPES = scopes
export const CAMS_API_BASE_URL = camsApiBaseUrl
export const FMP_API_BASE_URL = fmpApiBaseUrl
export const NRM_API_BASE_URL = nrmApiBaseUrl
export const PLANT_API_BASE_URL = plantApiBaseUrl
export const BASIC_AUTH_USER = basicAuthUsername
export const BASIC_AUTH_SECRET = basicAuthSecret
export const NRM_BASIC_AUTH_USER = nrmBasicAuthUsername
export const NRM_BASIC_AUTH_SECRET = nrmBasicAuthSecret
export const PLANT_BASIC_AUTH_USER = plantBasicAuthUsername
export const PLANT_BASIC_AUTH_SECRET = plantBasicAuthSecret
export const PLANT_LINZ_MAP_API_KEY = plantLinzMapApiKey

let WRM_URL = 'https://chorus-workrequestmanager-dev.demo.outwide.net' // DEV
switch (environment) {
  case 'PROD':
    WRM_URL = 'https://workrequestmanager.chorus.co.nz'
    break

  case 'PPE':
    WRM_URL = 'https://chorus-workrequestmanager-ppe.demo.outwide.net'
    break

  case 'SIT':
    WRM_URL = 'https://chorus-workrequestmanager-sit.demo.outwide.net'
    break
}

export const WRM_BASE_URL = WRM_URL
